function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import isString from 'lodash/isString';
var _React_PureComponent;
class Widget extends (_React_PureComponent = React.PureComponent) {
    renderMessage(message) {
        if (!message) {
            return null;
        }
        if (isString(message)) {
            return message;
        }
        return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, message));
    }
    renderHeader() {
        const { isNoHeader, headerMessage, headerAdditionalMessage } = this.props;
        if (isNoHeader) {
            return null;
        }
        return /*#__PURE__*/ _jsxs("h2", {
            className: "widget__header",
            children: [
                this.renderMessage(headerMessage),
                headerAdditionalMessage ? /*#__PURE__*/ _jsx("span", {
                    className: cn('widget__header__additional', this.props.headerAdditionalMessageClassName),
                    children: this.renderMessage(headerAdditionalMessage)
                }) : null,
                /*#__PURE__*/ _jsx("hr", {})
            ]
        });
    }
    render() {
        const { isNoHeader, isInProgress, className, style, widgetId } = this.props;
        return /*#__PURE__*/ _jsx("div", {
            className: cn('widget', {
                'widget--noHeader': isNoHeader,
                'widget--in-progress': isInProgress
            }, className),
            "data-testid": widgetId,
            children: /*#__PURE__*/ _jsxs("div", {
                className: "widget__content",
                style: style,
                children: [
                    this.renderHeader(),
                    this.props.children
                ]
            })
        });
    }
}
_define_property(Widget, "propTypes", {
    // Explicit props
    widgetId: PropTypes.string.isRequired,
    children: PropTypes.node,
    style: PropTypes.object,
    headerMessage: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    headerAdditionalMessage: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    isNoHeader: PropTypes.bool,
    isInProgress: PropTypes.bool,
    className: PropTypes.string,
    headerAdditionalMessageClassName: PropTypes.string
});
_define_property(Widget, "defaultProps", {
    isNoHeader: false,
    style: {}
});
export default Widget;
